import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { TextInput, SelectInput, PrimaryButton } from './common/FormControls';

const Appointments = () => {
  const [appointments, setAppointments] = useState([]);
  const [form, setForm] = useState({
    patientId: '',
    doctorId: '',
    appointmentDate: '',
    appointmentTime: '',
    type: 'consultation',
  });

  useEffect(() => {
    fetchAppointments();
  }, []);

  const fetchAppointments = async () => {
    try {
      const response = await axios.get(`${window.location.protocol}//${window.location.hostname}/api/appointments`);
      setAppointments(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${window.location.protocol}//${window.location.hostname}/api/appointments`, form);
      setForm({
        patientId: '',
        doctorId: '',
        appointmentDate: '',
        appointmentTime: '',
        type: 'consultation',
      });
      fetchAppointments();
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  return (
    <div className="space-y-8">
      <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
        <h2 className="text-2xl font-semibold text-slate-800 mb-4">Appointments</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <TextInput
            label="Patient ID"
            name="patientId"
            value={form.patientId}
            onChange={handleChange}
            required
          />
          <TextInput
            label="Doctor ID"
            name="doctorId"
            value={form.doctorId}
            onChange={handleChange}
            required
          />
          <TextInput
            label="Appointment Date"
            name="appointmentDate"
            type="date"
            value={form.appointmentDate}
            onChange={handleChange}
            required
          />
          <TextInput
            label="Appointment Time"
            name="appointmentTime"
            type="time"
            value={form.appointmentTime}
            onChange={handleChange}
            required
          />
          <SelectInput
            label="Appointment Type"
            name="type"
            value={form.type}
            onChange={handleChange}
            options={[
              { value: 'consultation', label: 'Consultation' },
              { value: 'follow-up', label: 'Follow-up' },
              { value: 'check-up', label: 'Check-up' },
              { value: 'telemedicine', label: 'Telemedicine' },
            ]}
          />
          <PrimaryButton type="submit">Book Appointment</PrimaryButton>
        </form>
      </div>
      <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
        <h3 className="text-lg font-medium text-slate-700 mb-3">Appointment List</h3>
        <ul className="space-y-2">
          {appointments.map((appointment) => (
            <li key={appointment.id} className="rounded-lg bg-slate-50 p-3 text-sm text-slate-700">
              Patient {appointment.patientId} with Doctor {appointment.doctorId} on {appointment.appointmentDate} at {appointment.appointmentTime}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Appointments;